import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { HexColorPicker } from 'react-colorful';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@mui/styles';
import Box from '@mui/material/Box/Box';
import { InputLabel } from '@mui/material';
import PopoverDialog from '../Dialog/PopoverDialog';
const useStyles = makeStyles(theme => createStyles({
    body: {
        margin: 0,
        padding: '50px',
        font: 'normal 18px/1.4 Arial, sans-serif',
    },
    picker: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
    },
    swatch: {
        width: '28px',
        height: '28px',
        borderRadius: '8px',
        boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1)',
        cursor: 'pointer',
        marginLeft: '0.25rem',
        marginBottom: '0.25rem',
    },
}));
export const PopoverPicker = ({ color, onChange, label }) => {
    const classes = useStyles();
    return (_jsxs(Box, { className: clsx(classes.picker), children: [_jsxs(InputLabel, { children: [label, ":"] }), _jsx(PopoverDialog, { buttonProps: {
                    className: clsx(classes.swatch),
                    style: { backgroundColor: color },
                }, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, children: _jsx(HexColorPicker, { color: color, onChange: onChange }) })] }));
};
const ColorPicker = ({ value, onChange, label }) => {
    const handleChange = newColor => {
        onChange(newColor);
    };
    return (_jsx(PopoverPicker, { label: label, color: value, onChange: handleChange }));
};
export default ColorPicker;
